<template>
  <b-table striped borderless hover responsive class="position-relative" :busy="loading" :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc" sort-icon-left sticky-header no-border-collapse :items="mappedItems" show-empty
    :empty-text="$t('errors.emptyTable.title')" :empty-filtered-text="$t('errors.emptyTable.title')" :fields="fields">
    <template #table-busy>
      <div class="text-center text-primary my-2">
        <b-spinner class="align-middle mr-2" />
        <strong>{{ $t("Carregant") }}...</strong>
      </div>
    </template>

    <!-- <template #cell(owner)="data">
      {{ data.item.owner.fullName }}
    </template> -->

  </b-table>
</template>

<script>
import { BTable, BSpinner } from "bootstrap-vue";
import { formatCurrency, formatDateObjectToDate } from "@/utils/formatters";

export default {
  components: {
    BTable,
    BSpinner,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      sortBy: "date",
      sortDesc: true,
      fields: [
        { key: "owner", label: this.$t("Propietari"), sortable: true },
        { key: "idNumber", label: this.$t("NIF"), sortable: true },
        { key: "amountT1", label: this.$t("Contrap. T1"), sortable: false },
        { key: "amountT2", label: this.$t("Contrap. T2"), sortable: false },
        { key: "amountT3", label: this.$t("Contrap. T3"), sortable: false },
        { key: "amountT4", label: this.$t("Contrap. T4"), sortable: false },
        { key: "bookingsT1", label: this.$t("Reserves T1"), sortable: false },
        { key: "bookingsT2", label: this.$t("Reserves T2"), sortable: false },
        { key: "bookingsT3", label: this.$t("Reserves T3"), sortable: false },
        { key: "bookingsT4", label: this.$t("Reserves T4"), sortable: false },
        { key: "commissionsT1", label: this.$t("Comissions T1"), sortable: false },
        { key: "commissionsT2", label: this.$t("Comissions T2"), sortable: false },
        { key: "commissionsT3", label: this.$t("Comissions T3"), sortable: false },
        { key: "commissionsT4", label: this.$t("Comissions T4"), sortable: false },
        { key: "taxesT1", label: this.$t("Impostos T1"), sortable: false },
        { key: "taxesT2", label: this.$t("Impostos T2"), sortable: false },
        { key: "taxesT3", label: this.$t("Impostos T3"), sortable: false },
        { key: "taxesT4", label: this.$t("Impostos T4"), sortable: false },
      ],
    };
  },
  computed: {
    mappedItems() {
      if (!this.items.length) return [];
      return this.items.map((item) => ({
        owner: item.owner.fullName || this.$t("No definit"),
        idNumber: item.owner.idNumber || this.$t("No definit"),
        amountT1: formatCurrency(item.quarters[1].totalOwnerRatesPrice) || this.$t("No definit"),
        amountT2: formatCurrency(item.quarters[2].totalOwnerRatesPrice) || this.$t("No definit"),
        amountT3: formatCurrency(item.quarters[3].totalOwnerRatesPrice) || this.$t("No definit"),
        amountT4: formatCurrency(item.quarters[4].totalOwnerRatesPrice) || this.$t("No definit"),
        bookingsT1: item.quarters[1].bookings.length || 0,
        bookingsT2: item.quarters[2].bookings.length || 0,
        bookingsT3: item.quarters[3].bookings.length || 0,
        bookingsT4: item.quarters[4].bookings.length || 0,
        commissionsT1: formatCurrency(item.quarters[1].totalProfitPrice) || this.$t("No definit"),
        commissionsT2: formatCurrency(item.quarters[2].totalProfitPrice) || this.$t("No definit"),
        commissionsT3: formatCurrency(item.quarters[3].totalProfitPrice) || this.$t("No definit"),
        commissionsT4: formatCurrency(item.quarters[4].totalProfitPrice) || this.$t("No definit"),
        taxesT1: formatCurrency(item.quarters[1].totalCommissionVatPrice) || this.$t("No definit"),
        taxesT2: formatCurrency(item.quarters[2].totalCommissionVatPrice) || this.$t("No definit"),
        taxesT3: formatCurrency(item.quarters[3].totalCommissionVatPrice) || this.$t("No definit"),
        taxesT4: formatCurrency(item.quarters[4].totalCommissionVatPrice) || this.$t("No definit"),
      }));
    },
  },
  methods: {
    bookingFormattedDate(date) {
      const formatting = {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      };
      return (
        formatDateObjectToDate(date, this.$i18n.locale, formatting) ||
        "No definit"
      );
    },
  },
};
</script>

<style></style>
